import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SelectControl, SelectItem } from 'src/app/form-controls/select/select.control';
import { UnitValue, UnitValueControl } from 'src/app/form-controls/unit-value/unit-value.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { BladderSize, CheckBladderSizeActionV2, Palpation } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface CheckBladderSizeActionFormGroup {
	size: FormControl<BladderSize | null>;
	scannedSize: FormControl<UnitValue | null>;
	palpation: FormControl<Palpation | null>;
}

@Component({
    selector: 'app-check-bladder-size-action-controls-v2',
    templateUrl: './check-bladder-size-action-controls-v2.component.html',
    styleUrls: ['../../../common.scss', './check-bladder-size-action-controls-v2.component.scss'],
    imports: [ReactiveFormsModule, UnitValueControl, SelectControl, CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckBladderSizeActionControlsComponentV2 implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: CheckBladderSizeActionV2;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as CheckBladderSizeActionV2;
	}

	@Input() form!: FormGroup<CheckBladderSizeActionFormGroup>;
	@Input() item!: Row | null;
	
	size: SelectItem[] = [
		{ text: 'Small', value: BladderSize.Small },
		{ text: 'Medium', value: BladderSize.Medium },
		{ text: 'Large', value: BladderSize.Large },
	];

	palpation: SelectItem[] = [
		{ text: 'Soft', value: Palpation.Soft },
		{ text: 'Hard', value: Palpation.Hard },
		{ text: 'Moderate', value: Palpation.Moderate },
	];

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('size', this.formBuilder.control(this.action?.size ?? null));
		this.form.addControl('scannedSize', this.formBuilder.control(this.action?.scannedSize ?? null));
		this.form.addControl('palpation', this.formBuilder.control(this.action?.palpation ?? null));
	}
}